import http from './http';

export default {
  async loadData(payload) {
    const response = await http.get(`/${payload.path}`, {});
    return response.data;
  },
  async putData(payload) {
    const response = await http.put(`/${payload.path}`, payload.data);
    return response.data;
  },
  async updateData(payload) {
    const response = await http.patch(`/${payload.path}`, payload.data);
    return response.data;
  },
  async createData(payload) {
    const response = await http.post(`${payload.path}`, payload.data, {
      headers: payload.headers,
    });
    return response.data.data;
  },
};
